// components/GenreFeed.tsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ChevronLeft, Dice5 } from "lucide-react";
import {Toolbar} from "../components/Toolbar";
import { AudioTrack } from "../components/AudioTrack";
import { GenreFeedService } from "../services/GenreFeedService";
import { TrackData } from "../types/Types";
import "../styles/GenreFeed.css";

export const GenreFeed: React.FC = () => {
  const { genre } = useParams<{ genre: string }>();
  const navigate = useNavigate();

  const [tracks, setTracks] = useState<TrackData[]>([]);
  const [loading, setLoading] = useState(true);

  const decodedGenre = genre ? decodeURIComponent(genre) : "Unknown Genre";

  useEffect(() => {
    const fetchGenreSongs = async () => {
      setLoading(true);
      if (decodedGenre && decodedGenre !== "Unknown Genre") {
        const fetchedTracks = await GenreFeedService.fetchTracksByGenre(
          decodedGenre
        );
        setTracks(fetchedTracks);
      }
      setLoading(false);
    };

    fetchGenreSongs();
  }, [decodedGenre]);

  const handleRandomizeClick = () => {
    const shuffled = [...tracks].sort(() => 0.5 - Math.random());
    setTracks(shuffled);
  };

  if (loading) {
    return (
      <div className="genre-feed-container">
        <Toolbar />
        <div className="genre-feed-loading">Loading Tracks...</div>
      </div>
    );
  }

  return (
    <div className="genre-feed-container">
      <Toolbar />
      <section className="inner-page-layout">
        <section className="inner-page-content">
          <button className="genre-feed-back-btn" onClick={() => navigate(-1)}>
            <ChevronLeft size={20} />
            Back
          </button>

          <div className="genre-feed-banner">
            <h1 className="genre-feed-name">{decodedGenre}</h1>
            <h2 className="genre-feed-description">Genre Feed</h2>
          </div>

          <button
            className="genre-feed-randomize-btn"
            onClick={handleRandomizeClick}
            disabled={tracks.length === 0}
          >
            <Dice5 size={18} style={{ marginRight: "8px" }} />
            Randomize
          </button>

          <section className="genre-feed-tracks-container">
            {tracks.length > 0 ? (
              tracks.map((track) => <AudioTrack key={track.id} track={track} />)
            ) : (
              <div className="no-tracks-message">
                No tracks found for {decodedGenre}.
              </div>
            )}
          </section>
        </section>
      </section>
    </div>
  );
};

export default GenreFeed;
